import { useContext, useEffect, useState } from 'react';
import { Button, Accordion, Card, AccordionContext, useAccordionButton } from 'react-bootstrap';
import { isAccordionItemSelected } from 'react-bootstrap/esm/AccordionContext';
import { config } from 'Utils/config';

function AccordionHeader({ text, eventKey, callback }) {
    const { activeEventKey } = useContext(AccordionContext);
    const isCurrentEventKey = isAccordionItemSelected(activeEventKey, eventKey);

    const onClick = useAccordionButton(
        eventKey,
        () => {
            return callback && callback((p) => {
                if(isCurrentEventKey==true){
                    // Remove event key
                    return p.filter(i => {
                        return i != eventKey
                    });
                }
                else{
                    // Add event key
                    return [...p, eventKey];
                }
            })
        },
    );

    return (
        <Card.Header as={Button} variant={"comp-clear"} onClick={onClick} className="d-flex flex-row justify-content-between align-items-center">
            <h3 className="text-start mb-0 header1 bold color-primary-navyblue">{text}</h3>
            <div>
                {   
                    isCurrentEventKey
                    ?   
                        <div className="arrow-icon-div">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M19 13H5V11H19V13Z" fill="#193F64"/>
                            </svg>
                        </div>
                    :   <div className="arrow-icon-div">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" fill="#193F64"/>
                            </svg>
                        </div>
                }
            </div>
        </Card.Header>
    );
}

function DetailCardSection({detailCardsData, tabActiveKey}) {
    //Open accordion keys
    const [activeKeys, setActiveKeys] = useState([]);
    
    useEffect(()=>{
        config.isDebugEnabled && console.log(detailCardsData);

        //On data change, reset active keys
        setActiveKeys([]);
    },[detailCardsData])
    
    return (
        <Accordion className="details-card-section d-flex flex-column" defaultActiveKey={[]} activeKey={activeKeys} alwaysOpen key={"detail-card-section-"+tabActiveKey}>
            {
                detailCardsData.map((card)=>{
                    if(card.desc != null){
                        return(
                            <Card className="detail-card" key={"detail-card-section-row-"+card.key}>
                                <AccordionHeader eventKey={card.key} text={card.header} callback={setActiveKeys}></AccordionHeader>
                                <Accordion.Collapse eventKey={card.key}>
                                    <Card.Body>
                                        <Card.Text className="body regular color-base-darkergray">{card.desc}</Card.Text>
                                    </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                        )
                    }
                })
            }
        </Accordion>
    );
}

export default DetailCardSection;